import { render, staticRenderFns } from "./capabilities-list-edit.vue?vue&type=template&id=905fd246&scoped=true"
import script from "./capabilities-list-edit.vue?vue&type=script&lang=js"
export * from "./capabilities-list-edit.vue?vue&type=script&lang=js"
import style0 from "./capabilities-list-edit.vue?vue&type=style&index=0&id=905fd246&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "905fd246",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('905fd246')) {
      api.createRecord('905fd246', component.options)
    } else {
      api.reload('905fd246', component.options)
    }
    module.hot.accept("./capabilities-list-edit.vue?vue&type=template&id=905fd246&scoped=true", function () {
      api.rerender('905fd246', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/supplier/edit-poppers/capabilities-list-edit.vue"
export default component.exports